<template>
  <v-card class="d-flex flex-column">
    <ConfigHistoryDialog ref="historyDialog" />
    <ConfigDebugDialog ref="debugDialog" />
    <CopyConfigsDialog ref="copyDialog" />

    <ODialogBar no-close class="card-bar gap-4" title="Configurações do Módulo">
      <v-spacer />
      <v-btn icon title="Histórico" @click="showHistory">
        <v-icon>mdi-history</v-icon>
      </v-btn>
      <v-btn icon title="Preview" @click="preview">
        <v-icon>mdi-code-braces</v-icon>
      </v-btn>
      <OMenuButton :menuOpts="menuOpts" icon="mdi-content-copy" />
    </ODialogBar>

    <v-list expand style="overflow-y: auto">

      <ConfigEmbedStatus :vehicle="vehicle" :allConfigs="allConfigs"/>

      <!-- Itens que não possuem filhos -->
      <CANDictConfigItem
        :vehicle="vehicle"
        :allConfigs="allConfigs"
        @save="saveData"
      />
      <RPMConfigItem
        :vehicle="vehicle"
        :allConfigs="allConfigs"
        @save="saveData"
      />
      <SpeedConfigItem
        :vehicle="vehicle"
        :allConfigs="allConfigs"
        @save="saveData"
      />
      <OdoConfigItem
        :vehicle="vehicle"
        :allConfigs="allConfigs"
        @save="saveData"
      />
      <HoroConfigItem
        :vehicle="vehicle"
        :allConfigs="allConfigs"
        @save="saveData"
      />
      <BrakeConfigItem
        :vehicle="vehicle"
        :allConfigs="allConfigs"
        @save="saveData"
      />

      <!-- Itens que possuem filhos -->
      <v-list-group
        multiple
        no-action
        v-for="groupDef in groupDefs"
        :key="groupDef.groupName"
      >
        <template v-slot:activator>
          <v-list-item-title>
            {{ groupDef.groupName }}
          </v-list-item-title>
        </template>

        <component
          class="pl-6"
          v-for="configDef in groupDef.configs"
          :key="configDef.code"
          :is="configDef.vueComponent"
          :vehicle="vehicle"
          :allConfigs="allConfigs"
          :configDef="configDef"
          @save="saveData"
        />
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import RPMConfigItem from './RPMConfigItem.vue'
import SpeedConfigItem from './SpeedConfigItem.vue'
import OdoConfigItem from './OdoConfigItem.vue'
import HoroConfigItem from './HoroConfigItem.vue'
import BrakeConfigItem from './BrakeConfigItem.vue'
import CANDictConfigItem from './CANDictConfigItem.vue'
import ConfigGroups from './ConfigGroups.js'
import ConfigHistoryDialog from './ConfigHistoryDialog.vue'
import ConfigDebugDialog from './ConfigDebugDialog.vue'
import CopyConfigsDialog from './CopyConfigsDialog.vue'
import ConfigEmbedStatus from './ConfigEmbedStatus.vue'
import { Vehicle } from '../../../models'

export default {
  expose: ['reload'],
  components: {
    ConfigListItem,
    RPMConfigItem,
    SpeedConfigItem,
    OdoConfigItem,
    HoroConfigItem,
    BrakeConfigItem,
    CANDictConfigItem,
    ConfigHistoryDialog,
    ConfigDebugDialog,
    CopyConfigsDialog,
    ConfigEmbedStatus
  },
  props: {
    vehicle: { required: true }
  },
  watch: {
    vehicle() {
      this.reload()
    }
  },
  data() {
    return {
      menuOpts: [
        {
          text: 'Copiar de outro veículo...',
          icon: 'mdi-import',
          onClick: () => this.copyFromVehicle()
        },
        {
          text: 'Copiar para o clipboard',
          icon: 'mdi-export',
          onClick: () => this.copyToClipboard()
        }
      ],
      allConfigs: [],
      txtFilter: null,
      groupDefs: ConfigGroups
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },
    async copyFromVehicle() {
      let res = await this.$refs.copyDialog.open()
      if (res != null) this.saveData(res)
    },

    copyToClipboard() {
      let obj = {
        type: 'vehicleConfigs',
        origin: this.vehicle.code,
        configs: this.allConfigs
      }
      let str = JSON.stringify(obj, null, ' ')
      navigator.clipboard.writeText(str)
      this.$snack(`Configurações copiadas para o clipboard`)
    },

    preview() {
      this.$refs.debugDialog.open(this.vehicle.id, this.allConfigs)
    },

    showHistory() {
      this.$rootLoading(async () => {
        await this.fetchData()
        this.$refs.historyDialog.open(this.vehicle.id)
      })
    },

    async fetchData() {
      let res = await Vehicle.getConfigs(this.vehicle.id)
      this.allConfigs = res
    },

    async saveData(body) {
      this.$rootLoading(async () => {
        await Vehicle.patchConfigs(this.vehicle.id, body)
        await this.fetchData()
        this.$snack('Configurações salvas com sucesso')
      })
    }
  }
}
</script>

<style>
.configs-scroll {
  overflow-y: auto;
}
</style>
